// #2358 (WO-2260-UIF): /api/crm now requires a Supabase session bearer
// token. The app calls it with plain fetch() from ~40 places, so instead of
// editing each one this wraps window.fetch once and attaches the current
// session token to same-origin /api/crm requests only. No other request is
// touched, and a caller-supplied Authorization header always wins.
import { supabase } from './supabase';

export function isCrmUrl(input) {
  try {
    const raw = typeof input === 'string' ? input : input?.url;
    if (!raw) return false;
    const u = new URL(raw, window.location.origin);
    return u.origin === window.location.origin && u.pathname === '/api/crm';
  } catch (e) {
    return false;
  }
}

export function installCrmAuthFetch() {
  if (typeof window === 'undefined' || window.__crmAuthFetchInstalled) return;
  window.__crmAuthFetchInstalled = true;
  const orig = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    if (!isCrmUrl(input)) return orig(input, init);
    try {
      const { data } = await supabase.auth.getSession();
      const token = data?.session?.access_token;
      if (token) {
        const headers = new Headers(init?.headers || (typeof input !== 'string' ? input.headers : undefined));
        if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
        return orig(input, { ...(init || {}), headers });
      }
    } catch (e) {
      // fall through: send as-is, server will answer 401
    }
    return orig(input, init);
  };
}
